<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="photo50">
<h1 class="part-number---IVP" id="sigil_toc_id_1" title="Part One: Bottom">Part One</h1>
</div>
<h2 class="part-title---IVP sigil_not_in_toc" id="_idParaDest-2"><a id="_idTextAnchor001"></a>BOTTOM</h2>
<div>
<p class="dingbat" id="_idContainer006"><img alt="" src="Images/4324_graphic_TP1.png"/></p>
</div>
<p class="body"><span class="pagebreak" id="page10" title="10"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?13c813f4